import $ from 'jquery';
// import { throttle } from 'lodash';

/**
 * @desc Implements autoplay video in brightcove player
 * */
export default class CityTvVideo {
  /**
   * @param {string} playerContainer
   */
  constructor(playerContainer) {
    this.$window = $(window);
    this.$container = $(playerContainer);
    this.$videoPlayer = this.$container.find('.video-js');
    this.$close = this.$container.find('.close');
    this.init();
  }

  async init() {
    if (this.$container.hasClass('mobilesticky')) {
        this.player = window.videojs.getPlayer(this.$videoPlayer[0]);
        this.$close.on('click', () => { this.player.pause(); });

        const playerChange = (mutationList) => {
          mutationList.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              if (this.$videoPlayer.hasClass('vjs-playing')) {
                this.$container.addClass('sticky');
              } else {
                this.$container.removeClass('sticky');
              }
            }
          });
        };

        const observer = new MutationObserver(playerChange);
        observer.observe(this.$videoPlayer[0], { attributes: true });

        const intersecobserver = new IntersectionObserver(
          ([e]) => { this.$container[0].classList.toggle('is-stuck', e.intersectionRatio < 1); },
          { threshold: [1] },
        );

        intersecobserver.observe(this.$container.find('.intersection')[0]);
    }
  }
}
